export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f041ed06587408f20c311ace4fdb30b18bdb2e06b&name=fetchTypeahead!'